var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutside),expression:"clickOutside"}],ref:"theControl",staticClass:"creator-mention-dropdown-control",style:(_vm.theStyle)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }